import { defineNuxtPlugin } from '#app/nuxt'
import { LazyDialogAccount, LazyDialogAzContest, LazyDialogCommunitySlider, LazyDialogFilters, LazyDialogFrequentlyAskedQuestions, LazyDialogHotspotShop, LazyDialogImageViewer, LazyDialogMegaMenu, LazyDialogPartners, LazyDialogQuickshop, LazyDialogSearchHub, LazyDialogSheerId, LazyDialogSocialMediaShare, LazyCmsEventCollection, LazyCmsMegaMenuL1, LazyCmsMegaMenuL2, LazyCmsMegaMenuL3, LazyCmsPromoBar, LazyCmsPromoBarMessage, LazyCmsRecommendationCarousel, LazyCmsAccordions, LazyCmsAnchor, LazyCmsArticleCarousel, LazyCmsArticleGridV2, LazyCmsArticleGrid, LazyCmsBannerBlockBelow, LazyCmsBannerBlurredSplit, LazyCmsBannerEspot, LazyCmsBannerImage, LazyCmsBannerImageStandard, LazyCmsBannerMenu, LazyCmsBannerOverlay, LazyCmsBannerSaleSplit, LazyCmsBannerSplit, LazyCmsBannerThin, LazyCmsBannerVideoParallax, LazyCmsBaseCaption, LazyCmsBaseButtonAction, LazyCmsBaseButtonCvent, LazyCmsBaseButtonEnroll, LazyCmsBaseButtonSimple, LazyCmsBaseExpandableCta, LazyCmsBaseEyebrow, LazyCmsBaseGradient, LazyCmsBaseParallaxLayer, LazyCmsBaseParallaxMedia, LazyCmsBaseResponsiveMedia, LazyCmsBenefitBar, LazyCmsBloomreachRecommendations, LazyCmsCategoryCard, LazyCmsCollection, LazyCmsCollectionColumnGallery, LazyCmsCollectionParallax, LazyCmsCollectionStandard, LazyCmsCollectionVerticalList, LazyCmsComingSoon, LazyCmsCountdown, LazyCmsCtaButtonCollection, LazyCmsCtaButton, LazyCmsDialog, LazyCmsDialogGeneric, LazyCmsExperiment, LazyCmsFilterBy, LazyCmsFooterItem, LazyCmsHero, LazyCmsHeroBlockBelow, LazyCmsHeroProductOverlay, LazyCmsHeroStandard, LazyCmsIconAndTextCollection, LazyCmsLayoutArticleV2, LazyCmsLayoutArticle, LazyCmsLinkedCard, LazyCmsLoyaltyBanner, LazyCmsMegaMenu, LazyCmsMegaMenuL1Desktop, LazyCmsMegaMenuL1Mobile, LazyCmsMegaMenuL2Desktop, LazyCmsMegaMenuL2Mobile, LazyCmsMegaMenuL3Desktop, LazyCmsMegaMenuL3Mobile, LazyCmsMegaMenuMobile, LazyCmsMegaMenuVisualSelector, LazyCmsMegaMenuVisualSelectorCollection, LazyCmsMultiLinkCard, LazyCmsNewsletterSignup, LazyCmsParallax, LazyCmsParallaxGallery, LazyCmsPicture, LazyCmsPlainText, LazyCmsPopUp, LazyCmsPopUpManager, LazyCmsProductFeatures, LazyCmsProductFinder, LazyCmsProductGridInternal, LazyCmsProductGrid, LazyCmsRichText, LazyCmsRichTextAdvanced, LazyCmsRichTextSimple, LazyCmsRichTextStandard, LazyCmsSecondaryNavigation, LazyCmsSectionPositionProvider, LazyCmsSection, LazyCmsSegmentation, LazyCmsSharedButton, LazyCmsSharedCtaGroup, LazyCmsSharedHotZones, LazyCmsSharedHotZonesProductCard, LazyCmsSharedMedia, LazyCmsShopTheLookGallery, LazyCmsShopTheLookMosaic, LazyCmsShowcaseControls, LazyCmsShowcaseFrame, LazyCmsShowcaseViewer, LazyCmsSignIn, LazyCmsSpacer, LazyCmsThinBanner, LazyCmsUgc, LazyCmsUgcCuralate, LazyCmsUgcOlapic, LazyCmsUgcSocialNative, LazyCmsUgcSocialNativeMasonry, LazyCmsVideoPlayer, LazyCmsVideoCloudinaryPlayer, LazyCmsVideo, LazyDialogContent, LazyDialogEventDetail, LazyDialogMobileFilters, LazyDialogPromoBar, LazyDialogSocialNative, LazyDialogSocialNativeContent, LazyDialogSocialNativeReport, LazyDialogAddGiftOption, LazyDialogAddCreditCard, LazyDialogAddYourPhoto, LazyDialogAskMeAnythingSearch, LazyDialogAskQuestion, LazyDialogAskQuestionSuccess, LazyDialogBarcode, LazyDialogBopisStoreSearch, LazyDialogCartChangeShippingMethod, LazyDialogCartItemActionMenu, LazyDialogCartValidateShippingAddress, LazyDialogChangeStoreConfirmation, LazyDialogCreditedConsumerTerms, LazyDialogDeleteAddress, LazyDialogDeleteCard, LazyDialogEmployeeTerms, LazyDialogEuLegalGuarantee, LazyDialogForgotPassword, LazyDialogInfo, LazyDialogInterests, LazyDialogKlarna, LazyDialogLanguagePreference, LazyDialogLocationConfirmation, LazyDialogLoyaltyRedeemHybrid, LazyDialogLoyaltyRedeem, LazyDialogLoyaltySignUp, LazyDialogMarketingEnrollment, LazyDialogMiniCart, LazyDialogNotifyMe, LazyDialogPayconiq, LazyDialogPickupInStore, LazyDialogPickupInStoreReserve, LazyDialogProductDetailCard, LazyDialogProductReviews, LazyDialogProfileEnrichment, LazyDialogReportIssue, LazyDialogReviewUgc, LazyDialogReviewWrite, LazyDialogShippingAddress, LazyDialogShopTheLook, LazyDialogSignInAmazonSignOut, LazyDialogSignIn, LazyDialogSignInConfirmation, LazyDialogSignUp, LazyDialogSimplifiedEnrollment, LazyDialogSizeChart, LazyDialogStoreChanged, LazyDialogTermsAcceptance, LazyDialogTermsAndConditions, LazyDialogTest, LazyDialogThreeDsChallenge, LazyDialogVariantSelection, LazyDialogVideo, LazyDialogWelcome, LazyDialogYoutube } from '#components'
const lazyGlobalComponents = [
  ["DialogAccount", LazyDialogAccount],
["DialogAzContest", LazyDialogAzContest],
["DialogCommunitySlider", LazyDialogCommunitySlider],
["DialogFilters", LazyDialogFilters],
["DialogFrequentlyAskedQuestions", LazyDialogFrequentlyAskedQuestions],
["DialogHotspotShop", LazyDialogHotspotShop],
["DialogImageViewer", LazyDialogImageViewer],
["DialogMegaMenu", LazyDialogMegaMenu],
["DialogPartners", LazyDialogPartners],
["DialogQuickshop", LazyDialogQuickshop],
["DialogSearchHub", LazyDialogSearchHub],
["DialogSheerId", LazyDialogSheerId],
["DialogSocialMediaShare", LazyDialogSocialMediaShare],
["CmsEventCollection", LazyCmsEventCollection],
["CmsMegaMenuL1", LazyCmsMegaMenuL1],
["CmsMegaMenuL2", LazyCmsMegaMenuL2],
["CmsMegaMenuL3", LazyCmsMegaMenuL3],
["CmsPromoBar", LazyCmsPromoBar],
["CmsPromoBarMessage", LazyCmsPromoBarMessage],
["CmsRecommendationCarousel", LazyCmsRecommendationCarousel],
["CmsAccordions", LazyCmsAccordions],
["CmsAnchor", LazyCmsAnchor],
["CmsArticleCarousel", LazyCmsArticleCarousel],
["CmsArticleGridV2", LazyCmsArticleGridV2],
["CmsArticleGrid", LazyCmsArticleGrid],
["CmsBannerBlockBelow", LazyCmsBannerBlockBelow],
["CmsBannerBlurredSplit", LazyCmsBannerBlurredSplit],
["CmsBannerEspot", LazyCmsBannerEspot],
["CmsBannerImage", LazyCmsBannerImage],
["CmsBannerImageStandard", LazyCmsBannerImageStandard],
["CmsBannerMenu", LazyCmsBannerMenu],
["CmsBannerOverlay", LazyCmsBannerOverlay],
["CmsBannerSaleSplit", LazyCmsBannerSaleSplit],
["CmsBannerSplit", LazyCmsBannerSplit],
["CmsBannerThin", LazyCmsBannerThin],
["CmsBannerVideoParallax", LazyCmsBannerVideoParallax],
["CmsBaseCaption", LazyCmsBaseCaption],
["CmsBaseButtonAction", LazyCmsBaseButtonAction],
["CmsBaseButtonCvent", LazyCmsBaseButtonCvent],
["CmsBaseButtonEnroll", LazyCmsBaseButtonEnroll],
["CmsBaseButtonSimple", LazyCmsBaseButtonSimple],
["CmsBaseExpandableCta", LazyCmsBaseExpandableCta],
["CmsBaseEyebrow", LazyCmsBaseEyebrow],
["CmsBaseGradient", LazyCmsBaseGradient],
["CmsBaseParallaxLayer", LazyCmsBaseParallaxLayer],
["CmsBaseParallaxMedia", LazyCmsBaseParallaxMedia],
["CmsBaseResponsiveMedia", LazyCmsBaseResponsiveMedia],
["CmsBenefitBar", LazyCmsBenefitBar],
["CmsBloomreachRecommendations", LazyCmsBloomreachRecommendations],
["CmsCategoryCard", LazyCmsCategoryCard],
["CmsCollection", LazyCmsCollection],
["CmsCollectionColumnGallery", LazyCmsCollectionColumnGallery],
["CmsCollectionParallax", LazyCmsCollectionParallax],
["CmsCollectionStandard", LazyCmsCollectionStandard],
["CmsCollectionVerticalList", LazyCmsCollectionVerticalList],
["CmsComingSoon", LazyCmsComingSoon],
["CmsCountdown", LazyCmsCountdown],
["CmsCtaButtonCollection", LazyCmsCtaButtonCollection],
["CmsCtaButton", LazyCmsCtaButton],
["CmsDialog", LazyCmsDialog],
["CmsDialogGeneric", LazyCmsDialogGeneric],
["CmsExperiment", LazyCmsExperiment],
["CmsFilterBy", LazyCmsFilterBy],
["CmsFooterItem", LazyCmsFooterItem],
["CmsHero", LazyCmsHero],
["CmsHeroBlockBelow", LazyCmsHeroBlockBelow],
["CmsHeroProductOverlay", LazyCmsHeroProductOverlay],
["CmsHeroStandard", LazyCmsHeroStandard],
["CmsIconAndTextCollection", LazyCmsIconAndTextCollection],
["CmsLayoutArticleV2", LazyCmsLayoutArticleV2],
["CmsLayoutArticle", LazyCmsLayoutArticle],
["CmsLinkedCard", LazyCmsLinkedCard],
["CmsLoyaltyBanner", LazyCmsLoyaltyBanner],
["CmsMegaMenu", LazyCmsMegaMenu],
["CmsMegaMenuL1Desktop", LazyCmsMegaMenuL1Desktop],
["CmsMegaMenuL1Mobile", LazyCmsMegaMenuL1Mobile],
["CmsMegaMenuL2Desktop", LazyCmsMegaMenuL2Desktop],
["CmsMegaMenuL2Mobile", LazyCmsMegaMenuL2Mobile],
["CmsMegaMenuL3Desktop", LazyCmsMegaMenuL3Desktop],
["CmsMegaMenuL3Mobile", LazyCmsMegaMenuL3Mobile],
["CmsMegaMenuMobile", LazyCmsMegaMenuMobile],
["CmsMegaMenuVisualSelector", LazyCmsMegaMenuVisualSelector],
["CmsMegaMenuVisualSelectorCollection", LazyCmsMegaMenuVisualSelectorCollection],
["CmsMultiLinkCard", LazyCmsMultiLinkCard],
["CmsNewsletterSignup", LazyCmsNewsletterSignup],
["CmsParallax", LazyCmsParallax],
["CmsParallaxGallery", LazyCmsParallaxGallery],
["CmsPicture", LazyCmsPicture],
["CmsPlainText", LazyCmsPlainText],
["CmsPopUp", LazyCmsPopUp],
["CmsPopUpManager", LazyCmsPopUpManager],
["CmsProductFeatures", LazyCmsProductFeatures],
["CmsProductFinder", LazyCmsProductFinder],
["CmsProductGridInternal", LazyCmsProductGridInternal],
["CmsProductGrid", LazyCmsProductGrid],
["CmsRichText", LazyCmsRichText],
["CmsRichTextAdvanced", LazyCmsRichTextAdvanced],
["CmsRichTextSimple", LazyCmsRichTextSimple],
["CmsRichTextStandard", LazyCmsRichTextStandard],
["CmsSecondaryNavigation", LazyCmsSecondaryNavigation],
["CmsSectionPositionProvider", LazyCmsSectionPositionProvider],
["CmsSection", LazyCmsSection],
["CmsSegmentation", LazyCmsSegmentation],
["CmsSharedButton", LazyCmsSharedButton],
["CmsSharedCtaGroup", LazyCmsSharedCtaGroup],
["CmsSharedHotZones", LazyCmsSharedHotZones],
["CmsSharedHotZonesProductCard", LazyCmsSharedHotZonesProductCard],
["CmsSharedMedia", LazyCmsSharedMedia],
["CmsShopTheLookGallery", LazyCmsShopTheLookGallery],
["CmsShopTheLookMosaic", LazyCmsShopTheLookMosaic],
["CmsShowcaseControls", LazyCmsShowcaseControls],
["CmsShowcaseFrame", LazyCmsShowcaseFrame],
["CmsShowcaseViewer", LazyCmsShowcaseViewer],
["CmsSignIn", LazyCmsSignIn],
["CmsSpacer", LazyCmsSpacer],
["CmsThinBanner", LazyCmsThinBanner],
["CmsUgc", LazyCmsUgc],
["CmsUgcCuralate", LazyCmsUgcCuralate],
["CmsUgcOlapic", LazyCmsUgcOlapic],
["CmsUgcSocialNative", LazyCmsUgcSocialNative],
["CmsUgcSocialNativeMasonry", LazyCmsUgcSocialNativeMasonry],
["CmsVideoPlayer", LazyCmsVideoPlayer],
["CmsVideoCloudinaryPlayer", LazyCmsVideoCloudinaryPlayer],
["CmsVideo", LazyCmsVideo],
["DialogContent", LazyDialogContent],
["DialogEventDetail", LazyDialogEventDetail],
["DialogMobileFilters", LazyDialogMobileFilters],
["DialogPromoBar", LazyDialogPromoBar],
["DialogSocialNative", LazyDialogSocialNative],
["DialogSocialNativeContent", LazyDialogSocialNativeContent],
["DialogSocialNativeReport", LazyDialogSocialNativeReport],
["DialogAddGiftOption", LazyDialogAddGiftOption],
["DialogAddCreditCard", LazyDialogAddCreditCard],
["DialogAddYourPhoto", LazyDialogAddYourPhoto],
["DialogAskMeAnythingSearch", LazyDialogAskMeAnythingSearch],
["DialogAskQuestion", LazyDialogAskQuestion],
["DialogAskQuestionSuccess", LazyDialogAskQuestionSuccess],
["DialogBarcode", LazyDialogBarcode],
["DialogBopisStoreSearch", LazyDialogBopisStoreSearch],
["DialogCartChangeShippingMethod", LazyDialogCartChangeShippingMethod],
["DialogCartItemActionMenu", LazyDialogCartItemActionMenu],
["DialogCartValidateShippingAddress", LazyDialogCartValidateShippingAddress],
["DialogChangeStoreConfirmation", LazyDialogChangeStoreConfirmation],
["DialogCreditedConsumerTerms", LazyDialogCreditedConsumerTerms],
["DialogDeleteAddress", LazyDialogDeleteAddress],
["DialogDeleteCard", LazyDialogDeleteCard],
["DialogEmployeeTerms", LazyDialogEmployeeTerms],
["DialogEuLegalGuarantee", LazyDialogEuLegalGuarantee],
["DialogForgotPassword", LazyDialogForgotPassword],
["DialogInfo", LazyDialogInfo],
["DialogInterests", LazyDialogInterests],
["DialogKlarna", LazyDialogKlarna],
["DialogLanguagePreference", LazyDialogLanguagePreference],
["DialogLocationConfirmation", LazyDialogLocationConfirmation],
["DialogLoyaltyRedeemHybrid", LazyDialogLoyaltyRedeemHybrid],
["DialogLoyaltyRedeem", LazyDialogLoyaltyRedeem],
["DialogLoyaltySignUp", LazyDialogLoyaltySignUp],
["DialogMarketingEnrollment", LazyDialogMarketingEnrollment],
["DialogMiniCart", LazyDialogMiniCart],
["DialogNotifyMe", LazyDialogNotifyMe],
["DialogPayconiq", LazyDialogPayconiq],
["DialogPickupInStore", LazyDialogPickupInStore],
["DialogPickupInStoreReserve", LazyDialogPickupInStoreReserve],
["DialogProductDetailCard", LazyDialogProductDetailCard],
["DialogProductReviews", LazyDialogProductReviews],
["DialogProfileEnrichment", LazyDialogProfileEnrichment],
["DialogReportIssue", LazyDialogReportIssue],
["DialogReviewUgc", LazyDialogReviewUgc],
["DialogReviewWrite", LazyDialogReviewWrite],
["DialogShippingAddress", LazyDialogShippingAddress],
["DialogShopTheLook", LazyDialogShopTheLook],
["DialogSignInAmazonSignOut", LazyDialogSignInAmazonSignOut],
["DialogSignIn", LazyDialogSignIn],
["DialogSignInConfirmation", LazyDialogSignInConfirmation],
["DialogSignUp", LazyDialogSignUp],
["DialogSimplifiedEnrollment", LazyDialogSimplifiedEnrollment],
["DialogSizeChart", LazyDialogSizeChart],
["DialogStoreChanged", LazyDialogStoreChanged],
["DialogTermsAcceptance", LazyDialogTermsAcceptance],
["DialogTermsAndConditions", LazyDialogTermsAndConditions],
["DialogTest", LazyDialogTest],
["DialogThreeDsChallenge", LazyDialogThreeDsChallenge],
["DialogVariantSelection", LazyDialogVariantSelection],
["DialogVideo", LazyDialogVideo],
["DialogWelcome", LazyDialogWelcome],
["DialogYoutube", LazyDialogYoutube],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
